<p class="chat-intro">{{ 'chat.intro' | translate }}</p>

@if (isStatusLoading) {
  <app-waiting [message]="'chat.loading' | translate"></app-waiting>
} @else if (statusError) {
  <app-rerun-task
    [message]="'chat.statusError' | translate"
    (rerun)="loadStatus()"
  ></app-rerun-task>
} @else if (!configured) {
  <app-inline-snackbar
    [type]="SnackbarType.INFO"
    [message]="'chat.notConfigured' | translate"
    [showCloseButton]="false"
  ></app-inline-snackbar>
} @else {
  <section class="chat">
    <div class="chat-feed" #feed>
      @if (messages.length === 0) {
        <div class="chat-capabilities">
          <p>{{ 'chat.capabilitiesTitle' | translate }}</p>
          @for (group of capabilities; track group.group) {
            <div class="capability-group">
              @for (item of group.items; track item.name) {
                <span class="chip">{{ item.label }}</span>
              }
            </div>
          }
        </div>
      }

      @for (message of messages; track $index) {
        <div
          class="chat-message"
          [class.user]="message.role === 'user'"
          [class.assistant]="message.role === 'assistant'"
          [class.error]="message.error"
        >
          @if (message.error) {
            <p>{{ 'chat.error' | translate }}</p>
          } @else if (message.role === 'assistant') {
            <markdown [data]="message.content"></markdown>
          } @else {
            <p>{{ message.content }}</p>
          }

          @if (message.toolCalls?.length) {
            <div class="tool-chips">
              @for (tool of message.toolCalls; track tool) {
                <span class="chip">{{ tool }}</span>
              }
            </div>
          }
        </div>
      }

      @if (isSending) {
        <div class="chat-message assistant thinking">
          <app-waiting [message]="'chat.thinking' | translate"></app-waiting>
        </div>
      }
    </div>

    <div class="chat-input">
      <textarea
        rows="1"
        [(ngModel)]="input"
        [placeholder]="'chat.placeholder' | translate"
        (keydown)="onInputKeydown($event)"
      ></textarea>
      <button
        mat-flat-button
        [disabled]="isSendDisabled"
        [class.disabled]="isSendDisabled"
        (click)="send()"
      >
        {{ 'chat.send' | translate }}
      </button>
    </div>
  </section>
}
